import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../api/client";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

const WishlistContext = createContext(null);
const LS = "makhana_wishlist";

export function WishlistProvider({ children }) {
    const { user } = useAuth();
    const [ids, setIds] = useState([]);

    const refresh = useCallback(async () => {
        if (user) {
            try {
                const { data } = await api.get("/wishlist");
                setIds(data.product_ids || []);
            } catch {}
        } else {
            try {
                setIds(JSON.parse(localStorage.getItem(LS) || "[]"));
            } catch {
                setIds([]);
            }
        }
    }, [user]);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const toggle = async (product) => {
        if (user) {
            const { data } = await api.post(`/wishlist/toggle/${product.id}`);
            setIds(data.product_ids);
            toast.success(data.added ? "Added to wishlist" : "Removed from wishlist");
        } else {
            const current = ids.includes(product.id)
                ? ids.filter((x) => x !== product.id)
                : [...ids, product.id];
            localStorage.setItem(LS, JSON.stringify(current));
            setIds(current);
            toast.success(ids.includes(product.id) ? "Removed from wishlist" : "Added to wishlist");
        }
    };

    const has = (id) => ids.includes(id);

    return (
        <WishlistContext.Provider value={{ ids, toggle, has, refresh }}>
            {children}
        </WishlistContext.Provider>
    );
}

export const useWishlist = () => useContext(WishlistContext);
